import Application from 'careers/services/application'
import { actions } from 'react-redux-form'
import { httpError } from 'actions/http'
import { deleteVideoResponse, updateVideoResponse } from 'actions/video-response'
import { addError } from 'actions'

export const APPLICATION_SAVE = 'APPLICATION_SAVE'
export const APPLICATION_SAVED = 'APPLICATION_SAVED'
export const APPLICATION_REQUEST = 'APPLICATION_REQUEST'
export const APPLICATION_RECEIVE = 'APPLICATION_RECEIVE'

export const fetchApplication = params => dispatch => Application.get(params.token)
  .then((application) => {
    // On frontend we have parameter has which is in backend saved and
    // therefore we have to transform it here
    application.videoResponses.map((response) => {
      response.has = !!response.videoUrl
    })

    dispatch(actions.change('application', application))
  })
  .catch((err) => {
    if (err.response && err.response.status && [404, 410].includes(err.response.status)) {
      dispatch(httpError(err.response.status))
    } else {
      dispatch(addError(err))
    }
  })

export const applicationSaved = application => ({ type: APPLICATION_SAVED, application })

export const saveApplication = (application, referrer) => (dispatch, getState) => {
  const method = !application._id ? 'create' : 'update'
  const { files } = getState().global
  application.referrer = referrer

  // Fetch data uris from global files list (this is how attachments component works)
  const attachments = Array.isArray(application.attachments)
    ? application.attachments.map(attachment => attachment.key in files ? { ...attachment, datauri: files[attachment.key] } : attachment)
    : undefined

  return Application[method]({ ...application, attachments })
    .then((application) => {
      dispatch(applicationSaved(application))
      dispatch(actions.change(
        'application',
        {
          ...application,
          saved: true,
        },
      ))
    })
    .catch((err) => {
      if (err.response && err.response.status && [404, 410].includes(err.response.status)) {
        dispatch(httpError(err.response.status))
      } else {
        throw err
      }
    })
}

export const saveApplicationForLater = application => dispatch => Application.update(application, true)
  .then((application) => {
    dispatch(applicationSaved(application))
  })

export const saveDraft = payload => (dispatch) => {
  if (payload.isMobile) {
    return Application.putMobileVideoResponse(
      payload.applicationId,
      {
        ...payload.response,
      },
    )
      .then((videoResponse) => {
        dispatch(updateVideoResponse('application', videoResponse, videoResponse))
      })
  }
  return Application.putVideoResponse(
    payload.applicationId,
    {
      ...payload.response,
    },
  )
    .then((videoResponse) => {
      dispatch(updateVideoResponse('application', videoResponse, videoResponse))
    })
}

export const removeDraft = payload => dispatch => Application.deleteVideoResponse(
  payload.applicationId,
  {
    ...payload.response,
  },
)
  .then((videoResponse) => {
    dispatch(deleteVideoResponse('application', videoResponse, videoResponse))
  })
